import { useQuery } from '@tanstack/react-query';
import { getGatewayConversionSettings } from 'config/requests/orderConversion';

export function useGatewayConversionSettings(id: number | null) {
  return useQuery({
    queryKey: ['gateway_conversion_settings', id],
    queryFn: () => getGatewayConversionSettings(id || 0),
    retry: false,
    enabled: Boolean(id),
  });
}
